export default {
  // ── 导航 ──────────────────────────────────────────────────────────────────
  'home.nav.how_it_works': '工作原理',
  'home.nav.useCases': '使用场景',
  'home.nav.platform_stack': '平台技术栈',
  'home.nav.pricing': '定价',
  'home.nav.login': '登录',
  'home.nav.getStarted': '快速开始',

  // ── Hero ──────────────────────────────────────────────────────────────────
  'home.hero.badge': '来自 GameBot 团队——受到腾讯、Garena及 20+ 工作室的信赖',
  'home.hero.titleSuffix1': '将您的 AI 技术栈编织成',
  'home.hero.titleSuffix2': '一个平台',
  'home.hero.desc':
    // eslint-disable-next-line max-len
    '<span class="text-white/90 font-semibold">小型团队</span>无需花<span class="text-white/90 font-semibold">数月</span>搭建基础设施。通过工作流或代码构建，然后在<span class="text-white/90 font-semibold">一个生产技术栈</span>上部署、监控和管控成本——源自驱动<span class="text-blue-600 font-semibold">腾讯</span>和 <span class="text-blue-600 font-semibold">Garena</span> 的 <span class="text-blue-600 font-semibold">7 年</span>基础设施积淀。',
  'home.hero.cta': '开始构建',
  'home.hero.freeBadge': '$10 免费',
  'home.hero.noCreditCard': '无需信用卡',
  'home.hero.stat.years': '年生产环境经验',
  'home.hero.stat.countries': '服务覆盖国家',
  'home.hero.stat.concurrent': '峰值并发 Agent',
  'home.hero.stat.studios': '顶级游戏工作室',
  'home.hero.stats.description': `Since 2019, <span style="color: #4c4ce9; font-weight: bold;">GameBot</span> has powered AI agents for the world's top studios. 
<span style="color: #4c4ce9; font-weight: bold;">Knit</span> puts that same production stack in your hands.`,

  // ── Logo 轮播 ─────────────────────────────────────────────────────────────
  'home.logos.label': '源自为这些工作室提供动力。现在，由你来进一步发展。',

  // ── Why Now ───────────────────────────────────────────────────────────────
  'home.whyNow.title': '为什么是现在？',
  'home.whyNow.desc':
    'AI 正从演示走向产品。瓶颈不再仅仅是模型访问，而是围绕 Agent 和 AI 应用的生产技术栈——运行时、可观测性、成本控制、变现和运维。',
  'home.whyNow.quote': '的存在是为了让精干团队无需自建技术栈即可交付产品。',
  'home.whyNow.quotePrefix': '的存在是为了让',
  'home.whyNow.quoteHL1': '精干团队',
  'home.whyNow.quoteMid1': '无需自建',
  'home.whyNow.quoteHL2': '技术栈',
  'home.whyNow.quoteMid2': '即可',
  'home.whyNow.quoteHL3': '交付',
  'home.whyNow.quoteSuffix': '产品。',
  'home.whyNow.quoteBold': 'Knit',
  'home.whyNow.bottomPrefix': '基于 7 年 GameBot 基础设施——服务于 ',
  'home.whyNow.bottomHighlight1': 'Tencent',
  'home.whyNow.bottomMiddle': '、',
  'home.whyNow.bottomHighlight2': 'Garena',
  'home.whyNow.bottomSuffix': ' 及 20+ 工作室，',
  'home.whyNow.bottomHighlight3': '300 万并发规模',
  'home.whyNow.bottomEnd': '。',
  'home.whyNow.t1.title': 'GAMEBOT 成立',
  'home.whyNow.t1.desc': '首批企业级部署',
  'home.whyNow.t2.title': '',
  'home.whyNow.t2.desc': '300 万并发，服务 20+ 工作室',
  'home.whyNow.t3.title': '',
  'home.whyNow.t3.desc': 'AI 从演示转向 Agent 产品',
  'home.whyNow.t4.title': 'KNIT 发布',
  'home.whyNow.t4.desc': '面向所有开发者开放。',

  // ── 能力 ──────────────────────────────────────────────────────────────────
  'home.capabilities.label': '工作原理',
  'home.capabilities.titlePrefix': '从原型到生产',
  'home.capabilities.titleMiddle': '无需构建您自己的',
  'home.capabilities.titleHighlight': '技术栈。',
  'home.capabilities.subtitle':
    '快速构建。在托管运行时上发布。全程可视化运行。',
  'home.capabilities.card1.step': '01',
  'home.capabilities.card1.category': '构建',
  'home.capabilities.card1.title': '工作流或代码',
  'home.capabilities.card1.desc':
    '从 <span class="cap-hl">Copilot</span> 辅助的工作流开始，或在需要更多<span class="cap-hl">控制</span>时引入<span class="cap-hl">您自己的</span>应用和服务逻辑。',
  'home.capabilities.card2.step': '02',
  'home.capabilities.card2.category': '部署',
  'home.capabilities.card2.title': '托管运行时',
  'home.capabilities.card2.desc':
    '<span class="cap-hl">部署</span>到<span class="cap-hl">生产</span>环境，托管、发布、回滚和扩展全部<span class="cap-hl">为您处理</span>。',
  'home.capabilities.card3.step': '03',
  'home.capabilities.card3.category': '运维',
  'home.capabilities.card3.title': '成本、监控、商业化',
  'home.capabilities.card3.desc':
    '在<span class="cap-hl">一处</span>追踪使用量、错误和支出，<span class="cap-hl">计费</span>和商业化功能正在为<span class="cap-hl">选定团队</span>逐步推出。',

  // ── 团队 ──────────────────────────────────────────────────────────────────
  'home.teams.label': '适用人群',
  'home.teams.titlePrefix': '为最有可能',
  'home.teams.titleHighlight': '赢得 AI 竞赛的团队而建。',
  'home.teams.desc':
    '无论你是寻找产品市场契合点的 AI 初创公司、正在交付 Agent 应用的产品工程师，还是处理实时 AI 工作负载的游戏团队——你们都遇到了同样的基础设施瓶颈。Knit 帮你交付产品，无需自建基础设施。',
  'home.teams.card1.quote':
    '一个 3 人 AI 初创团队，零基础设施经验。他们向 Copilot 描述产品，它就自动生成工作流、配置数据库并完成部署——一切在晚饭前搞定。无需 Docker、无需 YAML、无需 DevOps 招聘。',
  'home.teams.card1.tag': '技术创始人 \u2022 AI 初创公司',
  'home.teams.card1.title': '从想法到产品上线，只需一个下午',
  'home.teams.card2.quote':
    '一个 4 人团队正准备招聘两名后端工程师，专门负责部署和监控。有了 Knit，他们取消了招聘计划，一周内发布了 MVP，把资金留给了产品迭代。',
  'home.teams.card2.tag': '早期阶段 \u2022 AI 初创公司',
  'home.teams.card2.title': '省掉基础设施招聘，直接发布 MVP',
  'home.teams.card3.quote':
    '一位游戏工作室创始人，曾在顶级工作室搭建过大规模基础设施。这次，他们选择部署在 Knit 上，而非从零开始——同等级别的基础设施，零运维负担。10 万并发 AI 玩家，轻松应对。',
  'home.teams.card3.tag': '独立游戏工作室',
  'home.teams.card3.title': '10 万并发 AI 玩家，零基础设施团队',

  // ── 技术栈网格 ────────────────────────────────────────────────────────────
  'home.stack.label': '平台技术栈',
  'home.stack.titlePrefix': '大多数 AI 团队最终不得不',
  'home.stack.titleHighlight': '手动拼凑',
  'home.stack.titleSuffix': '的生产技术栈。',
  'home.stack.subtitle': 'Knit 将工作流层、运行时层和运维层整合到一个平台中。',
  'home.stack.item1.title': '工作流和 Agent 构建器',
  'home.stack.item1.desc':
    '使用 Copilot 辅助的工作流和可视化编排，作为从创意到可运行 AI 产品的最快路径。',
  'home.stack.item2.badge': '私有测试',
  'home.stack.item2.title': '托管应用运行时',
  'home.stack.item2.desc':
    '部署基于代码的应用和服务，构建、发布和回滚在同一技术栈上为您处理。',
  'home.stack.item3.badge': '逐步推出',
  'home.stack.item3.title': '计费和商业化',
  'home.stack.item3.desc':
    '为在 Knit 上销售 AI 产品的选定团队提供基于用量的定价和订阅。',
  'home.stack.item4.title': '可观测性和监控',
  'home.stack.item4.desc':
    '检查故障，观察性能，监控工作流、Agent 和应用的生产行为。',
  'home.stack.item5.title': '显著的成本节省',
  'home.stack.item5.desc':
    '通过 GameBot 现有基础设施的大规模资源池降低计算和 API 成本。* 实时跟踪每个 Agent、API 调用和资源的支出。',
  'home.stack.item6.title': '全球基础设施',
  'home.stack.item6.desc':
    '在 65 个国家经过实战检验，由要求规模、弹性和严格成本控制的实时工作负载塑造。',

  // ── 平台替代 ──────────────────────────────────────────────────────────────
  'home.platform.badge': '为什么选择它',
  'home.platform.titleHighlight': '替换',
  'home.platform.titleSuffix': '碎片化的 AI 技术栈，使用一个生产平台。',
  'home.platform.subtitle1': '大多数团队最终拼凑工作流工具、托管、',
  'home.platform.subtitle2': '仪表盘、支付和自定义运维胶水代码。',
  'home.platform.subtitle3':
    'Knit 将这些技术栈压缩为一个专为 AI 产品打造的系统。',
  'home.platform.vs': 'VS',
  'home.platform.before.label': '碎片化技术栈',
  'home.platform.before.title': '5+ 个工具',
  'home.platform.before.desc':
    '工作流构建器 + 托管 + 仪表盘 + 支付 + 自定义运维胶水',
  'home.platform.before.item1': '工作流和运行时分散在不同系统中',
  'home.platform.before.item2': '可观测性和成本工具后期补充',
  'home.platform.before.item3': '变现功能零散拼凑',
  'home.platform.before.item4': '扩展逻辑分散在多个供应商',
  'home.platform.before.item5': '产品增长时需要更多胶水代码',
  'home.platform.after.label': '使用 KNIT',
  'home.platform.after.titleNum': '1',
  'home.platform.after.titleText': '个平台',
  'home.platform.after.desc': '一个用于构建、部署、运营和变现 AI 应用的技术栈',
  'home.platform.after.item1': '工作流和运行时在同一平台上',
  'home.platform.after.item2': '内置监控和成本管控',
  'home.platform.after.item3': '变现层与技术栈同步推出',
  'home.platform.after.item4': '从原型到规模化的生产路径',
  'home.platform.after.item5': '更少基础设施工作，更高产品速度',

  // ── 平台对比表格 ────────────────────────────────────────────────────────
  'home.platform.compare.label': '对 比',
  'home.platform.compare.col1': 'Knit',
  'home.platform.compare.col2': '工作流构建器',
  'home.platform.compare.col3': '通用托管',
  'home.platform.compare.col4': '自建',
  'home.platform.compare.row1': 'AI 工作流构建器',
  'home.platform.compare.row2': '托管应用运行时',
  'home.platform.compare.row3': '可观测性',
  'home.platform.compare.row4': '成本管控',
  'home.platform.compare.row5': '计费和变现',
  'home.platform.compare.row6': '从原型到生产，一个技术栈',
  'home.platform.compare.row7': '月均技术栈成本',
  'home.platform.compare.beta': 'Beta',
  'home.platform.compare.rollingOut': '逐步推出',
  'home.platform.compare.payg': '按量付费',
  'home.platform.compare.multiVendor': '多供应商',
  'home.platform.compare.infraAddons': '基础设施 + 附加组件',
  'home.platform.compare.cloudBill': '云账单 + 工程时间',

  // ── 设备展示 ──────────────────────────────────────────────────────────────
  'home.devices.title': '您的 AI 技术栈，随处可用',
  'home.devices.subtitle':
    '从任何设备监控、管理和部署。无论身在何处，完全掌控。',

  // ── 企业级 ────────────────────────────────────────────────────────────────
  'home.enterprise.label': '全球基础设施',
  'home.enterprise.titlePrefix': '企业级品质，\n现在为',
  'home.enterprise.titleHighlight': '您',
  'home.enterprise.titleSuffix': '所用。',
  'home.enterprise.subtitle':
    '7 年服务全球顶级游戏工作室。经过 300 万并发验证的相同基础设施，现在可用于您的产品。',
  'home.enterprise.card1.title': '安全与合规',
  'home.enterprise.card1.desc':
    'SOC 2 合规基础设施，静态和传输中加密。基于角色的访问控制和审计日志。',
  'home.enterprise.card2.title': '自定义部署',
  'home.enterprise.card2.desc':
    '部署到您自己的云、本地或混合环境。完全控制数据驻留。',
  'home.enterprise.card3.title': 'SLA 与支持',
  'home.enterprise.card3.desc':
    '99.99% 正常运行时间 SLA，企业计划享有专属支持和优先事件响应。',
  'home.enterprise.card4.title': '全球边缘网络',
  'home.enterprise.card4.desc':
    '从全球 13+ 个区域低延迟访问。自动故障转移和智能流量路由。',

  // ── 统计数据 ──────────────────────────────────────────────────────────────
  'home.stats.stat1': '年均服务小时数',
  'home.stats.stat2': '年均玩家交互次数',
  'home.stats.stat3': '峰值并发游戏 Agent',
  'home.stats.stat4': '日均活跃游戏会话',

  // ── 流程 ──────────────────────────────────────────────────────────────────
  'home.process.label': '实际演示',
  'home.process.titlePrefix': '从对话到生产环境',
  'home.process.titleHighlight': '不到一分钟。',
  'home.process.subtitle': '告诉 Copilot 您的需求，看着它构建、部署并上线。',
  'home.process.step1.title': '对话即创建',
  'home.process.step1.desc':
    '用自然语言描述您的需求。Copilot 将创意转化为可运行的工作流，完全无需编码。',
  'home.process.step2.title': '一键发布',
  'home.process.step2.desc':
    '瞬间推送到生产环境。零 DevOps，托管和环境设置全部为您处理。',
  'home.process.step3.title': '监控与增长',
  'home.process.step3.desc':
    '内置实时监控和成本管理。面向终端用户的计费和商业化功能即将推出。',
  'home.process.terminal.line1':
    '为我构建一个处理工单并回答常见问题的客服 Agent',
  'home.process.terminal.line2': 'Copilot 正在生成工作流...',
  'home.process.terminal.line3': '已创建：工单管理 + 常见问题查询',
  'home.process.terminal.line4': '已连接：知识库 + AI 路由',
  'home.process.terminal.line5': '正在部署到生产环境...',
  'home.process.terminal.line6': '监控已启用',
  'home.process.terminal.line7': '已上线于 ',
  'home.process.terminal.line8': '耗时 38 秒。已应用 $10 免费额度。',

  // ── 定价 ──────────────────────────────────────────────────────────────────
  'home.pricing.label': '定价',
  'home.pricing.titlePrefix': '从一个技术栈开始。',
  'home.pricing.titleHighlight': '按需付费增长。',
  'home.pricing.subtitle':
    '无隐性消费，无意外账单。免费开始，随业务增长灵活扩展。',
  'home.pricing.freeCredit': '免费额度',
  'home.pricing.payg': '随后按量付费',
  'home.pricing.desc':
    '大多数团队在获得第一个用户之前，需要花费 $50K-$200K 来构建托管、监控和基础设施。使用 Knit，您可以跳过这些步骤，在几分钟内上线。',
  'home.pricing.feature1': '注册即赠送免费额度',
  'home.pricing.feature2': '从第一天起解锁所有功能',
  'home.pricing.feature3': '按 Agent 运行、API 调用、计算资源付费',
  'home.pricing.feature4': '包含 Copilot 工作流构建器',
  'home.pricing.feature5': '托管、监控和成本管理',
  'home.pricing.feature6': '计费和商业化功能（即将推出）',
  'home.pricing.cta': '立即开始构建',

  // ── 最终 CTA ──────────────────────────────────────────────────────────────
  'home.final.titlePrefix': '打造产品。',
  'home.final.titleHighlight': '今天就发布。',
  'home.final.desc': `对于构建 AI Agent 和应用的团队来说，Knit 将多年的基础设施工作转化为一个生产就绪的平台。免费开始使用。零锁定。`,
  'home.final.cta': '免费开始构建',

  // ── 页脚 ──────────────────────────────────────────────────────────────────
  'home.footer.copy': '© 2026 Knit. 面向 AI Agent 和应用的生产级基础设施。',
  'home.footer.disclaimer':
    '* 成本节省基于内部基准测试，对比了 Knit的池化基础设施定价与主要云服务商的标准按需费率。实际节省可能因工作负载而异。本页上的示例场景代表典型用例，而非特定客户。',
  'home.footer.docs': '文档',
  'home.footer.github': 'GitHub',
  'home.footer.discord': 'Discord',
  'home.footer.twitter': 'Twitter',
  'home.footer.blog': '博客',
  'home.footer.pricing': '定价',
  'home.footer.status': '系统状态',
  'home.footer.privacy': '隐私政策',
  'home.footer.terms': '使用条款',
};
